@custom-media --mobile (max-width: 768px);

.stickyLegend {
  position: sticky;
  top: 0;
  display: block;
  z-index: 2;
  background-color: var(--white);

  @media (--mobile) {
    display: none;
  }

}
